import { render } from "./EditarEtapa.vue?vue&type=template&id=50ed1898"
import script from "./EditarEtapa.vue?vue&type=script&lang=js"
export * from "./EditarEtapa.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__